<template>
  <div class="tekenaarsheader">
    <div class="headerleft">
      <div class="ico">
        <img src="../../../assets/sidebar/home-ico.svg" alt="" />
      </div>
      <h2 class="header">Dashboard V3</h2>
      <a href="https://admin-v2.cad-tekenaar.com" target="_blank">
        <span
          >Ga naar V2
          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="square-arrow-up-right" class="svg-inline--fa fa-square-arrow-up-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M312 144H156.7c-13.25 0-24 10.75-24 24S143.5 192 156.7 192h97.34l-135 135c-9.375 9.375-9.375 24.56 0 33.94C123.7 365.7 129.8 368 136 368s12.28-2.344 16.97-7.031L288 225.9v97.34c0 13.25 10.75 24 24 24s24-10.75 24-24V168C336 154.8 325.3 144 312 144zM384 32H64C28.65 32 0 60.66 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.66 419.3 32 384 32zM400 416c0 8.82-7.178 16-16 16H64c-8.822 0-16-7.18-16-16V96c0-8.82 7.178-16 16-16h320c8.822 0 16 7.18 16 16V416z"></path></svg>
        </span>
      </a>
    </div>

    <div class="rightside">
      <div class="popupLogout" @click="signOut">
        <img src="@/assets/icons/logout-icon.png" alt="" />
        <span>Logout</span>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store"
//import SearchfieldWithReset from './SearchfieldWithReset'
import firebase from "firebase/app"

export default {
  name: "DashboardHeader",
  components: {
    // SearchfieldWithReset,
  },
  computed: {
    tekFilters() {
      return store.state.tekFilters
    }
  },
  methods: {
    fixupdate(e) {
      store.state.tekFilters.name = e
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          //   this.$router.replace({
          //     name: 'Videos'
          //   });
        })
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.headerleft span {
  background-color: rgb(46, 46, 226);
  cursor: pointer;
  color: white;
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-decoration: none;
}

span svg {
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
}

.v2 {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 10000px;
}
.header {
  color: #0b1125;

  opacity: 0.8;
  font-weight: 600;
  padding-right: 30px;
  font-size: 26px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.rightside {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.tekenaarsheader {
  z-index: 2;
  /* background-color: #FAFCFE; */
  background-color: #eff2f5;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  display: flex;
  width: 100%;
  height: 70px;
  align-items: center;
  padding: 50px 40px;
  /* border-bottom: 1px solid #E7E7F3; */
}

.searchbarholder {
  position: relative;
}
.reset-btn {
  position: absolute;
  width: 24px;
  height: 24px;
  top: 8px;
  right: 10px;
  cursor: pointer;
}
.searchfield {
  width: 200px;
  height: 40px;
  background-color: #e4ecfa;
  border-radius: 100px;
  border: none;
  font-size: 14px;
  padding: 10px 10px 10px 14px;
}
.active {
  background-color: #3076ea;
  color: white;
}

button {
  transform: translateX(-100px);
  color: #0475f2;
  border: 1px solid #0475f2;
  border-radius: 5px;
  padding: 8px 11px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  background-color: #eff2f5;
  margin-right: 20px;
}
button:hover {
  color: #fff;
  background-color: #0475f2;
}
button:active {
  color: #fff;
  background-color: #1b4d8d;
}

.popupLogout {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  transform: translateX(-100px);
  color: #606979;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}
.popupLogout:hover {
}
.popupLogout:hover img,
.popupLogout:hover span {
  transform: translateX(-5px);
}
.popupLogout img {
  max-height: 22px;
  margin-right: 10px;
  transition: 0.2s;
}
.popupLogout span {
  transition: 0.2s;
}
</style>
